import { createSelector } from 'reselect';

import { Plus100Status } from '~/src/entities/speed-bonus/context/constants';
import { TInitialState } from '~/src/entities/speed-bonus/context/reducer';

export const isShowSummary = createSelector(
    [
        (state: TInitialState) => state.connectionCost,
        (state: TInitialState) => state.tariff,
        (state: TInitialState) => state.routers,
    ],
    (cost, tariff, routers) => {
        if (typeof cost === 'undefined') {
            return false;
        }

        const isSelectedRouter = routers.some(router => router.quantity);

        return tariff?.speedBonusStatus === Plus100Status || isSelectedRouter;
    },
);
